import { commonjsGlobal as w } from "./index135.mjs";
import { __module as i } from "./index167.mjs";
i.exports;
(function(c) {
  (function(m, x, y) {
    function s(n) {
      var t = this, r = "";
      t.x = 0, t.y = 0, t.z = 0, t.w = 0, t.next = function() {
        var o = t.x ^ t.x << 11;
        return t.x = t.y, t.y = t.z, t.z = t.w, t.w ^= t.w >>> 19 ^ o ^ o >>> 8;
      }, n === (n | 0) ? t.x = n : r += n;
      for (var e = 0; e < r.length + 64; e++)
        t.x ^= r.charCodeAt(e) | 0, t.next();
    }
    function f(n, t) {
      return t.x = n.x, t.y = n.y, t.z = n.z, t.w = n.w, t;
    }
    function u(n, t) {
      var r = new s(n), e = t && t.state, o = function() {
        return (r.next() >>> 0) / 4294967296;
      };
      return o.double = function() {
        do
          var p = r.next() >>> 11, l = (r.next() >>> 0) / 4294967296, a = (p + l) / (1 << 21);
        while (a === 0);
        return a;
      }, o.int32 = r.next, o.quick = o, e && (typeof e == "object" && f(e, r), o.state = function() {
        return f(r, {});
      }), o;
    }
    x && x.exports ? x.exports = u : this.xor128 = u;
  })(
    w,
    c
  );
})(i);
var z = i.exports;
export {
  z as x
};
